
import * as Yup from 'yup';

//allows only dot and dash
const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
// const phoneNumberRegex = /^\+44[\s-]?(?:7\d{3}[\s-]?\d{6}|\d{2,4}[\s-]?\d{3,4}[\s-]?\d{3,4})$/;

const autoGetLocationFormSchema = {
    fullName: Yup.string()
        .required('Fullname is required')
        .min(2, 'Fullname should be at least 2 character long')
        .max(50, 'Fullname should not exceed 50 characters')
        .matches(/^[a-zA-Z\s]+$/, 'Name can only contain letters and spaces'),
        // .matches(
        //   /^[a-zA-Z\s'-]+$/,
        //   'Name can only contain letters, spaces, hyphens, and apostrophes'
        // ),
        // .matches(/^[a-zA-Z]+$/, 'Only alphabets are allowed'),
    email: Yup.string()
        .required('Email is required')
        .email('Email is invalid')
        .test('max-domain-length', 'The domain part of the email should not exceed 90 characters', (value) => {
            if (!value) return true; // Skip validation if the email is empty (handled by required above)
            const domainPart = value.split('@')[1];
            return domainPart && domainPart.length <= 100;
        })
        .matches(
            emailRegex,
            'Invalid email format. Only dashes (-) and dots (.) are allowed as special characters.'
        ),
    phoneNo: Yup.string()
        .nullable()
        .required(),
        // .test(
        //     'min-length',
        //     'Phone number must be at least 8 digits', // Adjust the minimum length message as needed
        //     (value) => !value || value.length >= 8 // Allows empty strings or checks for minimum length if entered
        // )
        // .max(20, 'Phone Number should not exceed 20 digits')
        // .test(
        //     'is-valid-phone',
        //     // 'Phone number must contain only numbers',
        //     (value) => !value || phoneNumberRegex.test(value) // Allows empty strings or matches the regex
        // ),
    location: Yup.mixed().required('Location is required'),
    password: Yup.string()
        .required('Password is required')
        .min(8, 'Password should be 8 characters long')
        .max(20, 'Password should not exceed 20 characters'),
        // .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
        // .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
        // .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character'),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .required('Confirm Password is required'),
}

const manualGetLocationFormSchema = {
    fullName: Yup.string()
        .required('Fullname is required')
        .min(2, 'Fullname should be at least 2 character long')
        .max(50, 'Fullname should not exceed 50 characters')
        .matches(/^[a-zA-Z]+$/, 'Only alphabets are allowed'),
    email: Yup.string()
        .required('Email is required')
        .email('Email is invalid')
        .test('max-domain-length', 'The domain part of the email should not exceed 90 characters', (value) => {
            if (!value) return true;
            const domainPart = value.split('@')[1];
            return domainPart && domainPart.length <= 100;
        })
        .matches(
            emailRegex,
            'Invalid email format. Only dashes (-) and dots (.) are allowed as special characters.'
        ),
    phoneNo: Yup.string()
        .nullable()
        .required(),
        // .test(
        //     'min-length',
        //     'Phone number must be at least 8 digits', // Adjust the minimum length message as needed
        //     (value) => !value || value.length >= 8 // Allows empty strings or checks for minimum length if entered
        // )
        // .max(20, 'Phone Number should not exceed 20 digits')
        // .test(
        //     'is-valid-phone',
        //     // 'Phone number must contain only numbers',
        //     (value) => !value || phoneNumberRegex.test(value) // Allows empty strings or matches the regex
        // ),
    location: Yup.mixed().required('Location is required'),
    password: Yup.string()
        .required('Password is required')
        .min(8, 'Password should be 8 characters long')
        .max(20, 'Password should not exceed 20 characters'),
        // .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
        // .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character'),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .required('Confirm Password is required'),
    address1: Yup.string()
        .required('Address is required')
        .min(2, 'Address should be at least 2 character long')
        .max(50, 'Address should not exceed 50 characters'),
    address2: Yup.string()
        .nullable()
        .notRequired()
        .test(
            'min-length',
            'Address must be at least 3 character long', // Adjust the minimum length message as needed
            (value) => !value || value.length >= 3 // Allows empty strings or checks for minimum length if entered
        )
        .max(20, 'Address should not exceed 20 digits'),
    town: Yup.string()
        .required('Town is required')
        .min(2, 'Town should be at least 2 character long')
        .max(20, 'Town should not exceed 20 characters'),
    postalCode: Yup.string()
        .required('Postal code is required')
        .min(2, 'Postal Code should be at least 2 character long')
        .max(10, 'Postal Code should not exceed 10 characters'),
    }

export { autoGetLocationFormSchema, manualGetLocationFormSchema }